
    import {
        Vue,
        Component
    } from 'vue-property-decorator'

    import AddOrUpdate from './category-add-or-update'
    @Component({
        name: 'caegory',
        components:{
            AddOrUpdate
        }
    })
    export default class caegory extends Vue {
        addOrUpdateVisible=false
        currentNo: number = 1;
        pageSize: number = 10;
        pageTotal: number = 0;
        dataList=[]
        showInfoVisible=false
        searchForm={
            name:''
        }
        loading: boolean = false;
        dataListSelections=[];
        created() {
          this.searchData();
        }

        handleSizeChange(val: number) {
            this.pageSize = val;
            this.getUserList();
        }
        handleCurrentChange(val: number) {
            this.currentNo = val;
            this.searchData();
        }
        // 多选
        selectionChangeHandle (val) {
            this.dataListSelections = val
        }
        addOrUpdate(val: any) {

            this.addOrUpdateVisible = true
            this.$nextTick(() => {
                this.$refs.addOrUpdate.init(val)
            })
        }
        deleteHandle (id) {
            let ids = id ? [id] : this.dataListSelections.map(item => {
                return item.id
            })
            if(!ids || ids.length==0) return
            this.$confirm
            (`确定进行[删除]操作?`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$http
                ({
                    url: `/bjba/category/delete`,
                    method: 'post',
                    data: ids
                }).then(({data}) => {
                    if (data && data.code === 200) {
                        this.$message
                        ({
                            message: '操作成功',
                            type: 'success',
                            duration: 1500
                        })
                        this.searchData()
                    } else if(data && data.code ==500) {
                        this.$message
                        ({
                            message: data.message,
                            type: 'error',
                            duration: 1500
                        })
                    }
                })
            }).catch(() => {
            })
        }
        changeIndex(){
            this.currentNo =1
        }
        searchData () {
            this.loading = true
            this.searchForm.page = this.currentNo;
            this.searchForm.pagesize = this.pageSize
            this.$request
                    .get('/bjba/category/list',{params:this.searchForm})
                    .then(res => {
            const {data} = res
            this.loading = false
            this.dataList = data.data.content
            this.pageTotal = data.data.totalElements
            }).catch(err => {
            this.$message
            ({
            message: '获取列表出现异常!',
            type: 'error',
            center: true,
            showClose: true
            })
            this.loading = false
            console.log(err)
            })
        }
    }
